var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",class:{ 'is-dark': _vm.$themeDark }},[(!_vm.appName.includes(' ') && _vm.appNameParts.length === 2)?[_c('span',{staticClass:"thin"},[_vm._v(_vm._s(_vm.appNameParts[0]))]),_c('span',{staticClass:"thick"},[_vm._v(_vm._s(_vm.appNameParts[1]))])]:[_c('span',{staticClass:"thick"},[_vm._v(_vm._s(_vm.appName))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }